import { CloseOutlined, SearchOutlined } from '@mui/icons-material';
import { IconButton, InputAdornment, TextField } from '@mui/material';
import { FunctionComponent, SetStateAction, useRef } from 'react';

export const SearchBar: FunctionComponent<{
  searchQuery: string,
  setSearchQuery: React.Dispatch<SetStateAction<any>>,
  placeholder?: string,
}> = ({ searchQuery, setSearchQuery, placeholder = 'Search' }) => {
  const inputRef = useRef<HTMLInputElement>(null);

  const searchHandler = (e: React.ChangeEvent<HTMLInputElement>) => {
    setSearchQuery(e.target.value)
  }

  // The clear button unmounts itself once the field empties, so put focus back
  // in the input rather than letting it drop to the page body.
  const clearHandler = () => {
    setSearchQuery('')
    inputRef.current?.focus()
  }

  return (
    <TextField
      fullWidth
      size='small'
      variant='outlined'
      placeholder={placeholder}
      value={searchQuery}
      onChange={searchHandler}
      inputRef={inputRef}
      InputProps={{
        startAdornment: (
          <InputAdornment position='start'>
            <SearchOutlined />
          </InputAdornment>),
        endAdornment: searchQuery ? (
          <InputAdornment position='end'>
            <IconButton
              aria-label='Clear search'
              size='small'
              edge='end'
              onClick={clearHandler}
            >
              <CloseOutlined fontSize='small' />
            </IconButton>
          </InputAdornment>
        ) : undefined,
      }}
    />
  )
}
